import { useState, useEffect } from 'react';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import SmsNotificationsCard from './SmsNotificationsCard';
import SmsNotificationForClientPanel from './SmsNotificationForClientPanel';
import { get, put } from '../../helpers/apiHelpers';

const SmsNotifications = ({ user, t }) => {
  const [state, setState] = useState({
    clientSms: [],
    clientToggleableSms: [],
    defaultConfigFromBrand: null,
  });

  useEffect(() => {
    // eslint-disable-next-line no-use-before-define -- FIXME
    fetchSmsConfigurations();

    get(user.company, {
      properties: ['defaultConfigFromBrand'],
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    }).then(res => {
      setState(prevState => ({
        ...prevState,
        defaultConfigFromBrand: res.defaultConfigFromBrand,
      }));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, []);

  const fetchSmsConfigurations = () => {
    const keySmsToSettingsClientPanel = ['bag_delivered'];
    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    get('sms-configurations').then(res => {
      const configurations = res['hydra:member'].map(configuration => ({
        ...configuration,
        hasChanged: false,
        isHidden: true,
        contentType:
          configuration.managedBySystem ||
          (configuration.enabledForOffice && !configuration.enabledForClient)
            ? 'office'
            : 'client',
      }));

      const clientToggleableSms = res['hydra:member'].filter(sms =>
        keySmsToSettingsClientPanel.includes(sms.smsKey)
      );
      setState(pervState => ({
        ...pervState,
        clientSms: configurations,
        clientToggleableSms,
      }));
    });
  };

  const handleSubmitSmsAllow = (functionState, sms) => {
    if (!sms.enabledForClient && sms.allowClientToToggle) {
      toast.warning(t('smsNotifications.smsDisabled'));
      return;
    }

    setState(prev => ({
      ...prev,
      clientToggleableSms: prev.clientToggleableSms.map(item => {
        if (item.id === sms.id) {
          return {
            ...item,
            hasChanged: false,
          };
        }
        return item;
      }),
    }));

    put(sms['@id'], {
      allowClientToToggle: sms?.allowClientToToggle,
    })
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .then(() => {
        toast.success(t('notify.changesSaved'));

        window.location.reload();
      })
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .catch(() => {
        toast.error(t('notify.noChangesSaved'));
      });
  };

  return (
    <>
      <SmsNotificationsCard
        title={t(
          'smsNotifications.cardTitle.client',
          'Powiadomienia SMS (dla klienta)'
        )}
        setState={setState}
        sms={state.clientSms}
        clientToggleableSms={state.clientToggleableSms}
        defaultConfigFromBrand={state.defaultConfigFromBrand}
      />
      <SmsNotificationForClientPanel
        state={state.clientToggleableSms}
        setState={setState}
        handleSubmit={handleSubmitSmsAllow}
      />
    </>
  );
};
// }

const mapStateToProps = state => ({
  brand: state.Auth.selectedBrand,
  user: state.Auth.user,
});

const enhance = compose(withTranslation(), connect(mapStateToProps, null));

export default enhance(SmsNotifications);
